import React, { useEffect } from 'react'
import Common from '../component/Common'
import headimg from '../images/image3.png'

import one from '../images/01.png'

const About = () => {
    useEffect(() => {
        document.title = "CareerGrads | About-Us"
    }, [])
    return (
        <div>
            <Common name={`Dont Just Choose Us Join Us`}
                imgsrc={headimg}
                visit='/contact'
                btname='Contact Now'
                content='Providing industry standard Training and Projects to students to find dream job' />

            <div className="container ">
                <h1 className="m-5 myborder">
                    Meet the Team
                </h1>
                <div className="row text-center">
                    <div className="col-10 mx-auto col-lg-4 col-sm-12 col-md-6 my-4">
                        <img src={one} className="img-fluid img-responsive my-4 rounded " />
                        <h3 className="text-uppercase ">George Sameul</h3>
                        <p>
                            FullStack Developer and Cloud Engineer
                        </p>
                    </div>
                    <div className="col-10 mx-auto col-lg-4 col-sm-12 col-md-6 my-4">
                        <img src={one} className="img-fluid img-responsive my-4 rounded " />
                        <h3 className="text-uppercase ">Kinna Grannis</h3>
                        <p>
                            FullStack Developer and Cloud Engineer
                        </p>
                    </div>
                    <div className="col-10 mx-auto col-lg-4 col-sm-12 col-md-6 my-4">
                        <img src={one} className="img-fluid img-responsive my-4 rounded " />
                        <h3 className="text-uppercase ">Mick Tayson</h3>
                        <p>
                            FullStack Developer and Cloud Engineer
                        </p>
                    </div>

                </div>
            </div>
            {
                window.scrollTo(0, 0)
            }
        </div>


    )
}

export default About
